
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {channels} from '@divvit/common-channels'
import Icon from 'components/Icon'
import classnames from 'classnames'

export default class ChannelTitle extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    iconSize: PropTypes.string,
    className: PropTypes.string
  }

  static defaultProps = {
    iconSize: '14px'
  }

  render() {
    const {id, iconSize, className} = this.props
    const channel = channels[id] || {}
    const classNames = classnames('channel-title', className)

    return (
      <div className={classNames}>
        <Icon className='channel-title_icon' name={`channel-${id}`} size={iconSize} />
        {channel.label}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/ChannelTitle/index.js